export default {
  tabTitle: 'Expert Knowledge Reference Models',
  createEkrm: 'Create EKRM',
  search: 'Search',
  edit: 'Edit',
  close: 'Close',
  clone: 'Clone',
  deleteEkrm: 'Delete EKRM',
  printJsonToConsole: 'Print JSON to console',
  downloadPkl: 'Download PKL',
  headerName: 'Name',
  headerMarket: 'Market',
  headerCreatedOn: 'Created on',
  headerCreatedBy: 'Created by',
  headerActions: 'Actions',
  building: 'Building...',
  updating: '(Updating...)',
  draftDialogTitle: 'Create EKRM',
  draftDialogText: "You've already started creating an EKRM. Do you want to continue that one, or dismiss it permanently and start from scratch?",
  continueBtn: 'Continue',
  startFromScratchBtn: 'Start from scratch',
  deleteDialogTitle: 'Warning',
  deleteDialogText: 'Deleting EKRM:',
  deleteDialogConfirm: 'It can be recovered for 7 days by asking an administrator. Are you sure?',
  deleteDialogConfirmBuilding: 'This action cannot be undone. Are you sure?',
  cancelBtn: 'Cancel',
  deleteBtn: 'Delete',
  snackEkrmDeleted: 'EKRM deleted',
  snackErrorDeletingEkrm: 'Error deleting EKRM',
  snackEkrmRenamed: 'EKRM renamed',
  snackErrorRenamingEkrm: 'Error renaming EKRM',
  snackPklDownloadStarted: 'PKL download started',
  snackErrorDownloadingPkl: 'Error downloading PKL file',
  inputTooLong: 'Input too long!'
}
